/**
 * @generated SignedSource<<2dfb4fce5866685ba97d87e1b65aa63e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddonOperationResultType = "ADDON_NOT_FOUND" | "DEVELOPMENT_STORE_ERROR" | "GENERIC_ERROR" | "NO_PREMIUM" | "SUCCESS";
export type useSubscriptionDataMutation$variables = {
  addonKey: string;
  currencyCode: string;
};
export type useSubscriptionDataMutation$data = {
  readonly activateAddonWithKey: AddonOperationResultType;
};
export type useSubscriptionDataMutation = {
  response: useSubscriptionDataMutation$data;
  variables: useSubscriptionDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addonKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currencyCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "addonKey",
        "variableName": "addonKey"
      },
      {
        "kind": "Variable",
        "name": "currencyCode",
        "variableName": "currencyCode"
      }
    ],
    "kind": "ScalarField",
    "name": "activateAddonWithKey",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubscriptionDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSubscriptionDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a3f0fc8efce781d19f63f1145cb5d52",
    "id": null,
    "metadata": {},
    "name": "useSubscriptionDataMutation",
    "operationKind": "mutation",
    "text": "mutation useSubscriptionDataMutation(\n  $addonKey: String!\n  $currencyCode: String!\n) {\n  activateAddonWithKey(addonKey: $addonKey, currencyCode: $currencyCode)\n}\n"
  }
};
})();

(node as any).hash = "1f4b12abd0c5482fbe12065acd122a4f";

export default node;
